const initialState = {
  loading: false,
  data: null,
  error: null,
};

const goalCategoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_GOAL_CATEGORY_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_GOAL_CATEGORY_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_GOAL_CATEGORY_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default goalCategoriesReducer;
